{
  "_comments_for_translators": "Latin American Spanish (es), neutral LATAM register — 'ustedes' over 'vosotros', 'computadora' over 'ordenador'. Soybean farmer audience (Argentina/Bolivia/Paraguay/Brazil border being the largest soy region). Rules a future translator MUST preserve: (1) Technical tokens NDVI and Sentinel-2 stay as-is in all languages — DO NOT translate. (2) The product term 'stall' (a learned UI term in en/el) is rendered consistently as 'estancamiento' here — pick one and stick with it. The alternative 'parada de crecimiento' was considered and rejected for being verbose. (3) Plain-language driver labels (DO NOT use index acronyms like NDRE/PSRI etc.): biomass = 'densidad del dosel'; chlorophyll = 'verdor de las hojas'; water = 'humedad'; senescence = 'envejecimiento prematuro'; structure = 'estructura del dosel'. (4) 'field' = 'lote' (Argentine/Uruguayan/Paraguayan/Bolivian soybean-farmer standard). Mexican/Central-American audiences may prefer 'parcela' or 'campo' — flagged for agronomist review. (5) Preserve every {placeholder} marker EXACTLY as in en.json — key names and braces are load-bearing. (6) 'soja' over 'soya' (more universal across the South-American soy belt; Mexico uses 'soya' but the dominant LATAM soy region uses 'soja'). LLM translation pass — agronomist review pending; see docs/i18n_agronomist_review.md.",
  "sidebar.navigationLabel": "Navegación principal",
  "sidebar.themeToggleLight": "Cambiar a modo claro",
  "sidebar.themeToggleDark": "Cambiar a modo oscuro",
  "nav.main": "Secciones principales",
  "welcome.mapAria": "Mapa interactivo de límites del lote",
  "welcome.locating": "Buscando tu ubicación...",
  "welcome.drawButtonAria": "Dibujar un nuevo límite de lote",
  "welcome.drawingHintKeyboard": "Presioná Esc para cancelar el dibujo.",
  "welcome.drawingLiveArea": "Área estimada: {area}",
  "welcome.drawingHintTouch": "Tocá para colocar puntos. Tocá el primer punto para cerrar.",
  "welcome.drawingHintTouchPan": "Usá dos dedos para mover el mapa.",
  "welcome.drawingToolbarAria": "Herramientas de dibujo",
  "welcome.undoVertexAria": "Deshacer último punto",
  "welcome.finishPolygonAria": "Cerrar polígono y finalizar dibujo",
  "welcome.cancelDrawingAria": "Cancelar dibujo",
  "welcome.undo": "Deshacer",
  "welcome.finish": "Finalizar",
  "advisor.inputAria": "Preguntale al asesor",
  "advisor.runSelectLabel": "Seleccioná una simulación guardada",
  "advisor.deleteRun": "Eliminar simulación guardada",
  "advisor.confirmDeleteRun": "¿Eliminar esta simulación guardada?",
  "advisor.runDeleted": "Simulación guardada eliminada.",
  "satellite.ndviChartAria": "Gráfico de serie temporal NDVI",
  "satellite.ndviMean": "NDVI promedio",
  "field.dialogTitle": "Guardar Nuevo Lote",
  "field.dialogArea": "Área estimada: {size}",
  "field.dialogName": "Nombre del lote",
  "field.dialogNamePlaceholder": "Ingresá un nombre para el lote",
  "field.dialogCrop": "Cultivo",
  "field.dialogSaving": "Guardando...",
  "field.dialogSave": "Guardar Lote",
  "kpi.groupLabel": "Resumen de desempeño del lote",
  "kpi.ariaYield": "Rendimiento estimado {value}",
  "kpi.ariaProfit": "Ganancia estimada {value}",
  "kpi.ariaHealth": "Salud del lote {value}",
  "kpi.ariaCaptured": "Última imagen capturada {value}",
  "sidebar.title": "AGROPTIMIZER",
  "sidebar.subtitle": "Sistema de Inteligencia de Lotes",
  "sidebar.lightMode": "Modo Claro",
  "sidebar.darkMode": "Modo Oscuro",
  "sidebar.logout": "Salir",
  "sidebar.drawField": "+ Dibujar Nuevo Lote",
  "sidebar.yourFields": "Tus Lotes",
  "sidebar.yourFieldsAria": "Abrir lista de lotes",
  "sidebar.units.imperial": "Imperial",
  "sidebar.units.metric": "Métrico",
  "sidebar.sessionLanguage": "Idioma",
  "sidebar.sessionUnits": "Unidades de Medida",
  "common.retry": "Reintentar",
  "common.close": "Cerrar",
  "common.cancel": "Cancelar",
  "prefs.unitsLabel": "Unidades de Medida",
  "prefs.languagePlaceholder": "Seleccioná el idioma",
  "prefs.unitsPlaceholder": "Seleccioná las unidades",
  "prefs.language.english": "English (US)",
  "prefs.language.greek": "Ελληνικά",
  "prefs.language.portuguese": "Português (Brasil)",
  "prefs.language.spanish": "Español",
  "prefs.required": "Elegí el idioma y las unidades de medida antes de continuar.",
  "params.title": "Configuración de la Simulación",
  "params.fieldConditions": "Condiciones del Lote",
  "params.irrigation": "Riego",
  "params.irrigation.rainfed": "Secano",
  "params.irrigation.irrigated": "Bajo Riego",
  "params.prevCrop": "Cultivo Anterior",
  "params.prevCrop.corn": "Maíz",
  "params.prevCrop.soybean": "Soja",
  "params.prevCrop.wheat": "Trigo",
  "params.prevCrop.rice": "Arroz",
  "params.prevCrop.cotton": "Algodón",
  "params.prevCrop.fallow": "Barbecho",
  "params.prevCrop.sorghum": "Sorgo",
  "params.prevCrop.otherCereal": "Otro Cereal",
  "params.prevCrop.otherLegume": "Otra Leguminosa",
  "params.prevCrop.smallGrains": "Cereales Finos",
  "params.prevCrop.other": "Otro",
  "params.soilType": "Tipo de Suelo",
  "params.soilType.siltLoam": "Franco-Limoso",
  "params.soilType.sandyLoam": "Franco-Arenoso",
  "params.soilType.clayLoam": "Franco-Arcilloso",
  "params.soilType.siltyClayLoam": "Franco-Arcillo-Limoso",
  "params.soilType.loamySand": "Arena Franca",
  "params.soilType.loam": "Franco",
  "params.soilType.clay": "Arcilla",
  "params.soilType.sand": "Arena",
  "params.soilType.silt": "Limo",
  "params.soilType.sandyClayLoam": "Franco-Arcillo-Arenoso",
  "params.soilType.siltyClay": "Arcillo-Limoso",
  "params.soilType.muck": "Suelo Orgánico",
  "params.soilOM": "MO del Suelo (%)",
  "params.soilPH": "pH del Suelo",
  "params.phosphorus": "Fósforo",
  "params.phosphorus.high": ">50 ppm",
  "params.phosphorus.medium": "36–50 ppm",
  "params.phosphorus.low": "25–35 ppm",
  "params.phosphorus.veryLow": "<25 ppm",
  "params.potassium": "Potasio",
  "params.potassium.high": ">175 ppm",
  "params.potassium.medium": "131–175 ppm",
  "params.potassium.low": "61–130 ppm",
  "params.potassium.veryLow": "<61 ppm",
  "params.management": "Estrategia de Manejo",
  "params.plantMonth": "Mes de Siembra",
  "params.month.january": "Enero",
  "params.month.february": "Febrero",
  "params.month.march": "Marzo",
  "params.month.april": "Abril",
  "params.month.may": "Mayo",
  "params.month.june": "Junio",
  "params.month.july": "Julio",
  "params.month.august": "Agosto",
  "params.month.september": "Septiembre",
  "params.month.october": "Octubre",
  "params.month.november": "Noviembre",
  "params.month.december": "Diciembre",
  "params.plantDay": "Día",
  "params.maturityGroup": "Grupo de Madurez",
  "params.relativeMaturity": "Madurez Relativa (días)",
  "params.seedingRate": "Densidad de Siembra ({unit})",
  "params.rowSpacing": "Distancia entre Hileras ({unit})",
  "params.tillage": "Sistema de Labranza",
  "params.tillage.conventional": "Convencional",
  "params.tillage.noTill": "Siembra Directa",
  "params.tillage.stripTill": "Labranza en Franjas",
  "params.foliarFungicide": "Fungicida Foliar",
  "params.seedTreatment": "Curasemilla",
  "params.foliarFert": "Fertilizante Foliar",
  "params.coverCrop": "Cultivo de Cobertura",
  "params.apply": "Aplicar",
  "params.no": "No",
  "params.fertility": "Fertilidad Aplicada",
  "params.nitrogen": "Nitrógeno ({unit})",
  "params.nitrogenSplit": "Fraccionamiento de Nitrógeno ({unit})",
  "params.nitrogenTotal": "Total:",
  "params.nitrogenSplitNote": "El N total entre todas las aplicaciones no puede superar {max} lb/ac — ajustar un control limita los otros.",
  "params.cornTotalNExceeded": "El nitrógeno total {total} lb/ac supera el máximo de {max} lb/ac. Reducí una de las fracciones de N antes de ejecutar.",
  "params.nPreSpring": "N Pre-Primavera",
  "params.nAtPlant": "N a la Siembra",
  "params.nPostPlant": "N Post-Siembra",
  "params.phosphorusRate": "Fósforo ({unit})",
  "params.potassiumRate": "Potasio ({unit})",
  "params.sulfurRate": "Azufre ({unit})",
  "params.economics": "Economía",
  "params.soybeanPrice": "Precio de referencia EE.UU. (NASS) — soja ({unit})",
  "params.cornPrice": "Precio de referencia EE.UU. (NASS) — maíz ({unit})",
  "params.seedCostSoy": "Costo de Semilla ($/140k)",
  "params.seedCostCorn": "Costo de Semilla ($/80k)",
  "params.fixedCosts": "Costos Fijos ({unit})",
  "params.fixedCosts.tooltip": "Gastos generales por acre no vinculados a un insumo específico — p. ej. alquiler de tierra, seguro de cultivo, maquinaria, mano de obra, combustible, reparaciones.",
  "params.seedTreatmentCost": "Curasemilla ({unit})",
  "params.coverCropSeed": "Semilla de Cobertura ({unit})",
  "params.dryingCost": "Costo de Secado ({unit})",
  "params.fertPrices": "Precios de Fertilizantes ({unit})",
  "params.fertNitrogen": "Nitrógeno",
  "params.fertPhosphorus": "Fósforo",
  "params.fertPotassium": "Potasio",
  "params.fertSulfur": "Azufre",
  "params.operations": "Operaciones ({unit})",
  "params.convTillage": "Labranza Convencional",
  "params.noTillPlanting": "Siembra Directa",
  "params.stripTillCost": "Labranza en Franjas",
  "params.applications": "Aplicaciones ({unit})",
  "params.fungInsectApp": "Fungicida/Insecticida Foliar + Aplicación",
  "params.fertApp": "Aplicación de Fertilizante",
  "params.foliarFertApp": "Fertilizante Foliar + Aplicación",
  "params.saveEcon": "Guardar Valores Económicos",
  "params.runSim": "Ejecutar Simulación",
  "params.running": "Ejecutando...",
  "params.working": "Procesando...",
  "tabs.advisor": "Asesor",
  "tabs.satellite": "Monitoreo",
  "welcome.title": "Ningún Lote Seleccionado",
  "welcome.description": "Dibujá un límite de lote en el mapa satelital de abajo, o seleccioná un lote existente desde la barra lateral para empezar tu análisis.",
  "welcome.drawBtn": "Dibujar Nuevo Lote",
  "advisor.chatPlaceholder": "Preguntale al agrónomo — maximizar ganancia, ranquear factores de rendimiento, comparar sistemas de labranza...",
  "advisor.send": "Enviar",
  "advisor.welcome": "¡Hola! Soy tu **Agrónomo IA**. Configurá los parámetros en el panel de la derecha y ejecutá una simulación para empezar. Puedo ayudarte a maximizar el rendimiento, optimizar la ganancia o evaluar el riesgo en distintos escenarios climáticos. O abrí la pestaña **Monitoreo** para configurar el seguimiento del lote y detectar problemas a tiempo.",
  "advisor.engineStarting": "🚜 **Iniciando el motor...** Esto suele tardar 2–3 minutos.",
  "advisor.paramsInvalid": "Parámetros inválidos — ajustalos y volvé a intentar.",
  "advisor.simResults": "**📊 Resultados de la Simulación**\n\nEvaluados **{n_scenarios}** escenarios en **{n_weather_years}** años climáticos.\n\n{'|'} Métrica {'|'} Valor {'|'}\n{'|'}---{'|'}---{'|'}\n{'|'} Rendimiento Promedio Estimado {'|'} **{yield_value}** {'|'}\n{'|'} Ganancia Estimada {'|'} **{profit_value}** {'|'}\n{'|'} Margen por Bushel {'|'} **{margin_value}** {'|'}\n\nPreguntame cómo interpretar estos resultados, maximizar la ganancia o ranquear los principales factores de rendimiento.",
  "advisor.simFailed": "❌ La simulación falló: {error}",
  "simulation.completeToast": "Simulación para '{field}' completada — {yield}",
  "simulation.failedToast": "La simulación para '{field}' falló.",
  "advisor.modifyInputs": "Modificar Parámetros",
  "advisor.hideInputs": "Ocultar Parámetros",
  "advisor.avg": "prom",
  "advisor.noRuns": "Sin simulaciones aún",
  "satellite.range": "rango",
  "satellite.insightAria": "Resumen de salud del lote",
  "satellite.insight.iconLabel": "Salud",
  "satellite.insight.firstImage": "Primera imagen de la campaña — vamos a seguir los cambios en las próximas pasadas.",
  "satellite.insight.noStall": "No se detectó estancamiento — la señal de vegetación de tu lote se mantuvo estable desde la última imagen clara.",
  "satellite.insight.flagged": "{pct}% del lote muestra crecimiento estancado desde la imagen anterior. Los manchones marcados aparecen en rojo sobre el mapa — evaluá el área afectada y la ubicación antes de decidir si vale la pena recorrer.",
  "satellite.insight.askAdvisor": "Consultá al Asesor sobre esta imagen",
  "advisor.autoPrompt.imageAnalysis": "Analizá la imagen satelital del {date} (DAP {dap}). ¿Qué cambió desde la imagen anterior y qué tendría que revisar?",
  "advisor.autoPrompt.imageAnalysisNoDap": "Analizá la imagen satelital del {date}. ¿Qué cambió desde la imagen anterior y qué tendría que revisar?",
  "advisor.autoPrompt.firstImageAnalysis": "Esta es la primera imagen satelital de la campaña para este lote, del {date} (DAP {dap}). ¿Qué indicadores de referencia tendría que monitorear desde acá y qué tendría que revisar en esta imagen?",
  "advisor.autoPrompt.firstImageAnalysisNoDap": "Esta es la primera imagen satelital de la campaña para este lote, del {date}. ¿Qué indicadores de referencia tendría que monitorear desde acá y qué tendría que revisar en esta imagen?",
  "satellite.state.noField.title": "Seleccioná un lote para empezar",
  "satellite.state.noField.body": "Dibujá o abrí un lote desde Tus Lotes para ver el monitoreo satelital.",
  "satellite.state.awaitingFirstImage.title": "Monitoreo activo — esperando la primera imagen",
  "satellite.state.awaitingFirstImage.body": "Esperando la próxima pasada del Sentinel-2. Tu primera imagen debería llegar dentro de los 5 días posteriores a la fecha de inicio del monitoreo, si el cielo está despejado. Las pasadas con nubes se omiten, por lo que puede tardar más en períodos nublados.",
  "satellite.state.monitoringActive.firstImageNote": "Primera imagen recibida. Vamos a tener una lectura de tendencia después de la próxima pasada clara.",
  "satellite.state.seasonComplete.title": "Campaña finalizada",
  "satellite.state.seasonComplete.body": "Tu ventana de monitoreo terminó. Revisá la campaña abajo, o planificá la próxima en el Asesor.",
  "satellite.state.seasonComplete.cta": "Planificar próxima campaña",
  "satellite.envelope.preCanopy": "Cobertura temprana — algunos índices aún no están activos. La cobertura de detección es reducida hasta que el cultivo cierre el dosel (alrededor de DAP 30).",
  "satellite.envelope.lateLimited": "Final de campaña — detección reducida. Algunos índices ya cerraron sus ventanas; la ausencia de alerta acá no garantiza ausencia de estrés.",
  "satellite.tooltip.stall.firstImage": "Primera imagen — sin tendencia aún",
  "satellite.tooltip.stall.none": "Sin estancamiento de crecimiento",
  "satellite.tooltip.stall.pct": "Estancamiento de crecimiento: {pct}% del lote",
  "satellite.stallRegionsCaption": "Regiones con estancamiento de crecimiento",
  "satellite.kpi.stall.firstImage": "Esperando tendencia",
  "satellite.kpi.stall.none": "Sin estancamiento",
  "satellite.kpi.stall.flagged": "Estancamiento detectado",
  "satellite.monitoringTitle": "Monitoreo del Lote",
  "satellite.monitoringSubtitle": "Elegí tu ventana de recorrida. La recorrida arranca como muy temprano 25 días después de la siembra. Vas a ver nuevas imágenes y análisis a medida que estén disponibles en ese período.",
  "satellite.monitoringPlantingDate": "Fecha de siembra: {date}",
  "satellite.editPlantingDateAria": "Editar fecha de siembra",
  "satellite.plantingDateSaveFailed": "No se pudo guardar la nueva fecha de siembra. Intentalo de nuevo.",
  "satellite.monitoringRangeLabel": "Ventana de recorrida (días después de la siembra)",
  "satellite.monitoringStartLabel": "Inicio de recorrida (días después de la siembra)",
  "satellite.monitoringEndLabel": "Fin de recorrida (días después de la siembra)",
  "satellite.monitoringStartDate": "Inicio: {date}",
  "satellite.monitoringEndDate": "Fin: {date}",
  "satellite.monitoringWindowSummary": "Ventana de monitoreo: {start} - {end} ({days} días)",
  "satellite.monitoringLockedSummary": "El monitoreo está bloqueado para este lote hasta que termine la ventana de recorrida.",
  "satellite.endAdjustLabel": "Ajustar fin de la ventana de monitoreo",
  "satellite.endAdjustHint": "La fecha de siembra y el inicio de la ventana están bloqueados porque ya se capturó la primera imagen satelital. Todavía podés mover el fin de la ventana hacia adelante o hacia atrás (hasta 95 días desde el inicio).",
  "satellite.endAdjustSaving": "Guardando...",
  "satellite.endAdjustSaved": "Ventana actualizada.",
  "satellite.endAdjustFailed": "No se pudo actualizar el fin de la ventana. Intentalo de nuevo.",
  "satellite.monitoringStartBtn": "Iniciar Monitoreo",
  "satellite.stopMonitoringBtn": "Detener Monitoreo",
  "satellite.stopMonitoringConfirmBody": "¿Detener los chequeos satelitales diarios para este lote? Las imágenes ya capturadas quedan en tu historial. Podés iniciar una nueva campaña más adelante.",
  "satellite.stopMonitoringConfirm": "Detener Monitoreo",
  "satellite.stopMonitoringSuccess": "Monitoreo detenido para este lote.",
  "satellite.stopMonitoringFailed": "No se pudo detener el monitoreo. Volvé a intentar.",
  "satellite.monitoringSeasonEnded": "Esta campaña terminó. Ajustá la fecha de siembra y la ventana arriba, y arrancá una nueva campaña.",
  "satellite.startNewSeason": "Iniciar Nueva Campaña",
  "satellite.monitoringNotStarted": "Monitoreo No Iniciado",
  "satellite.monitoringScheduled": "Monitoreo Programado",
  "satellite.monitoringComplete": "Monitoreo Finalizado",
  "satellite.monitoringMissingPlanting": "Elegí primero una fecha de siembra en el Asesor.",
  "satellite.latestImage": "Última Imagen",
  "satellite.dayAfterPlanting": "Día {dap} después de la siembra",
  "satellite.cloudCover": "Cobertura de nubes",
  "satellite.ndviScale": "NDVI",
  "satellite.monitoringActive": "Monitoreo Activo",
  "satellite.connecting": "Conectando al satélite...",
  "satellite.nextImage.one": "Próxima imagen en {days} día ({date})",
  "satellite.nextImage.other": "Próxima imagen en {days} días ({date})",
  "ndvi.preEmergence": "Pre-Emergencia",
  "toast.error": "Error",
  "toast.warning": "Aviso",
  "toast.success": "Listo",
  "toast.info": "Info",
  "help.title": "GUÍA AGROPTIMIZER",
  "help.placeholder": "Preguntá cómo usar la aplicación...",
  "help.send": "Enviar",
  "help.greeting": "¡Hola! Soy tu guía AGROPTIMIZER.\n\nPuedo ayudarte con:\n• Cómo dibujar un lote\n• Qué muestra cada pestaña\n• Ejecutar una simulación\n• Entender las imágenes satelitales\n• Cualquier otra duda sobre la plataforma\n\n¿Con qué necesitás ayuda?",
  "login.title": "AGROPTIMIZER",
  "login.subtitle": "Inteligencia de Lotes",
  "login.tabLogin": "Ingresar",
  "login.tabRegister": "Registrarse",
  "login.email": "Correo electrónico",
  "login.emailPlaceholder": "vos{'@'}ejemplo.com",
  "login.password": "Contraseña",
  "login.passwordPlaceholder": "••••••••",
  "login.loginBtn": "Ingresar",
  "login.forgotPassword": "¿Olvidaste la contraseña?",
  "login.loggingIn": "Ingresando...",
  "login.loginFailed": "Falló el ingreso",
  "register.email": "Correo electrónico",
  "register.emailPlaceholder": "vos{'@'}ejemplo.com",
  "register.password": "Contraseña",
  "register.passwordPlaceholder": "Mín. 8 caracteres",
  "register.confirmPassword": "Confirmar Contraseña",
  "register.confirmPlaceholder": "Repetí la contraseña",
  "register.createBtn": "Crear Cuenta",
  "register.creating": "Creando cuenta...",
  "register.passwordMismatch": "Las contraseñas no coinciden",
  "register.failed": "Falló el registro",
  "forgot.description": "Ingresá tu correo y te enviamos un enlace para restablecerla.",
  "forgot.email": "Correo electrónico",
  "forgot.emailPlaceholder": "vos{'@'}ejemplo.com",
  "forgot.sendBtn": "Enviar Enlace de Restablecimiento",
  "forgot.backToLogin": "← Volver a Ingresar",
  "forgot.sending": "Enviando...",
  "forgot.sendFailed": "No se pudo enviar el correo de restablecimiento. Intentalo de nuevo.",
  "forgot.linkSent": "Enlace de restablecimiento enviado.",
  "changePassword.title": "Cambiar Contraseña",
  "changePassword.currentPassword": "Contraseña Actual",
  "changePassword.currentPlaceholder": "••••••••",
  "changePassword.newPassword": "Nueva Contraseña",
  "changePassword.newPlaceholder": "Mín. 8 caracteres",
  "changePassword.confirmPassword": "Confirmar Nueva Contraseña",
  "changePassword.confirmPlaceholder": "Repetí la nueva contraseña",
  "changePassword.changeBtn": "Cambiar Contraseña",
  "changePassword.passwordMismatch": "Las contraseñas no coinciden",
  "changePassword.saving": "Guardando...",
  "changePassword.success": "¡Contraseña cambiada! Redirigiendo...",
  "changePassword.failed": "No se pudo cambiar la contraseña",
  "validation.password.tooShort": "La contraseña debe tener al menos 12 caracteres.",
  "validation.password.tooLong": "La contraseña debe tener como máximo 72 caracteres.",
  "validation.password.common": "Esta contraseña está entre las más filtradas. Elegí algo más único — una frase corta funciona bien.",
  "validation.password.weak": "La contraseña no es lo suficientemente fuerte.",
  "validation.password.criterion.length": "Al menos 12 caracteres",
  "validation.password.criterion.notCommon": "No es una contraseña común",
  "validation.password.show": "Mostrar contraseña",
  "validation.password.hide": "Ocultar contraseña",
  "error.auth.invalidCredentials": "Correo o contraseña inválidos",
  "error.auth.incorrectPassword": "La contraseña actual es incorrecta",
  "error.auth.deleteConfirmationMismatch": "Escribí ELIMINAR (en mayúsculas) para confirmar.",
  "error.auth.externalAuth": "Esta cuenta usa autenticación externa",
  "success.auth.accountDeleted": "Cuenta eliminada.",
  "success.auth.subscriptionCancelled": "Suscripción cancelada.",
  "login.passwordRequired": "La contraseña es obligatoria",
  "deleteAccount.title": "Eliminar Cuenta",
  "deleteAccount.warning": "Esto eliminará tu cuenta. Tus lotes, monitoreo satelital, simulaciones e historial de chat se conservarán por 30 días por si cambiás de idea, y después se borrarán de forma permanente. Volvé a ingresar dentro de los 30 días para cancelar la eliminación.",
  "deleteAccount.typeToConfirm": "Escribí ELIMINAR para confirmar",
  "deleteAccount.deleteBtn": "Eliminar Mi Cuenta",
  "deleteAccount.deleting": "Eliminando...",
  "deleteAccount.failed": "No se pudo eliminar la cuenta.",
  "cancelSubscription.title": "Cancelar Suscripción",
  "cancelSubscription.body": "Tu plan vuelve al nivel gratuito. Podés volver a suscribirte en cualquier momento y mantener tus lotes e historial.",
  "cancelSubscription.keepPlan": "Mantener Mi Plan",
  "cancelSubscription.confirmBtn": "Confirmar Cancelación",
  "cancelSubscription.cancelling": "Cancelando...",
  "cancelSubscription.success": "Suscripción cancelada.",
  "cancelSubscription.failed": "No se pudo cancelar la suscripción.",
  "changePassword.samePassword": "Tu nueva contraseña tiene que ser diferente de la actual.",
  "changePassword.weakPassword": "La contraseña no es lo suficientemente fuerte.",
  "account.title": "Mi Cuenta",
  "account.backToHome": "← Volver al Inicio",
  "account.navLabel": "Secciones de la cuenta",
  "account.nav.profile": "Perfil",
  "account.nav.security": "Seguridad",
  "account.nav.billing": "Facturación",
  "account.nav.dangerZone": "Zona de Riesgo",
  "account.profile.lede": "Los datos básicos de tu cuenta. Las preferencias de sesión se definen al ingresar.",
  "account.profile.email": "Correo electrónico",
  "account.profile.language": "Idioma",
  "account.profile.units": "Unidades",
  "account.profile.plan": "Plan",
  "account.profile.unitsImperial": "Imperial (acres, bu/ac)",
  "account.profile.unitsMetric": "Métrico (ha, kg/ha)",
  "account.profile.planFree": "Gratuito",
  "account.profile.languageChangeNote": "Elegí el idioma que querés para la aplicación, los correos y el asesor IA. El cambio aplica al instante.",
  "account.profile.languageChangedToast": "Idioma actualizado.",
  "account.profile.languageChangeFailedToast": "No se pudo cambiar tu idioma. Intentalo de nuevo.",
  "account.security.lede": "Actualizá tu contraseña. Cambiarla te desconectará de los otros dispositivos.",
  "account.billing.lede": "Tu plan de suscripción actual.",
  "account.billing.paidDescription": "Tenés acceso completo a las funciones de monitoreo y asesoría.",
  "account.billing.freeDescription": "Acceso básico. Hacé upgrade para monitoreo extendido y asesoría.",
  "account.billing.freeLede": "Estás en el plan gratuito.",
  "account.billing.cancelCopy": "Volvé al plan gratuito. Podés volver a hacer upgrade en cualquier momento.",
  "account.dangerZone.lede": "Acciones irreversibles. Verificá dos veces antes de confirmar.",
  "account.dangerZone.deleteDescription": "Programa tu cuenta para eliminación permanente. Tenés 30 días para restaurarla contactando a soporte.",
  "account.nav.connections": "Cuentas Conectadas",
  "account.connections.lede": "Iniciá sesión más rápido conectando un proveedor de identidad externo.",
  "account.connections.linked": "Conectada",
  "account.connections.notLinked": "No conectada",
  "account.connections.linkGoogle": "Conectar Google",
  "account.connections.unlinkGoogle": "Desconectar Google",
  "account.connections.requiresVerifiedEmail": "Verificá tu correo antes de conectar una cuenta de Google.",
  "account.connections.linkSuccessToast": "Google conectado con éxito.",
  "account.connections.unlinkSuccessToast": "Google desconectado.",
  "account.connections.linkDialog.title": "Conectar tu cuenta de Google",
  "account.connections.linkDialog.body": "Confirmá tu contraseña para iniciar la conexión con Google. Te vamos a redirigir a Google para conceder el acceso.",
  "account.connections.linkDialog.password": "Contraseña actual",
  "account.connections.linkDialog.continue": "Continuar a Google",
  "account.connections.linkDialog.linking": "Conectando...",
  "account.connections.linkDialog.failed": "No se pudo iniciar la conexión con Google. Intentalo de nuevo.",
  "account.connections.unlinkDialog.title": "Desconectar Google",
  "account.connections.unlinkDialog.titleEmail": "Confirmar por correo",
  "account.connections.unlinkDialog.bodyHybrid": "Confirmá tu contraseña para desconectar Google de tu cuenta. Vas a seguir ingresando con correo y contraseña.",
  "account.connections.unlinkDialog.bodyGoogleOnly": "Te vamos a enviar un enlace de confirmación al correo. Hacé clic para definir una nueva contraseña y desconectar Google. Sin contraseña perderías el acceso a tu cuenta.",
  "account.connections.unlinkDialog.password": "Contraseña actual",
  "account.connections.unlinkDialog.confirm": "Desconectar",
  "account.connections.unlinkDialog.disconnecting": "Desconectando...",
  "account.connections.unlinkDialog.sendEmail": "Enviar correo de confirmación",
  "account.connections.unlinkDialog.sending": "Enviando...",
  "account.connections.unlinkDialog.emailSentToast": "Te enviamos un enlace de confirmación al correo.",
  "account.connections.unlinkDialog.failed": "No se pudo desconectar Google. Intentalo de nuevo.",
  "account.connections.finalize.title": "Definí una contraseña y desconectá Google",
  "account.connections.finalize.body": "Definí una contraseña para tu cuenta. Vamos a desconectar Google en el mismo paso.",
  "account.connections.finalize.newPassword": "Nueva contraseña",
  "account.connections.finalize.confirmPassword": "Confirmar nueva contraseña",
  "account.connections.finalize.confirm": "Desconectar Google",
  "account.connections.finalize.submitting": "Desconectando...",
  "account.connections.finalize.mismatch": "Las contraseñas no coinciden.",
  "account.connections.finalize.weak": "La contraseña es demasiado débil.",
  "account.connections.finalize.failed": "No se pudo desconectar Google. Intentalo de nuevo.",
  "common.cancel": "Cancelar",
  "login.oauthOr": "o",
  "login.signInWithGoogle": "Iniciar sesión con Google",
  "login.emailVerifiedToast": "Correo verificado — ¡gracias!",
  "login.emailVerifyFailedToast": "El enlace de verificación es inválido o expiró. Iniciá sesión para solicitar uno nuevo.",
  "login.oauthError.cancelled": "Se canceló el inicio de sesión con Google.",
  "login.oauthError.state": "La sesión de inicio expiró o es inválida. Intentá de nuevo.",
  "login.oauthError.token": "No se pudo completar el inicio de sesión con Google. Intentá de nuevo.",
  "login.oauthError.deactivated": "Esta cuenta fue desactivada.",
  "login.oauthError.emailConflict": "Ya existe una cuenta con este correo. Iniciá sesión con correo/contraseña y conectá Google desde la configuración de tu cuenta.",
  "login.oauthError.googleUnverified": "El correo de tu cuenta de Google no está verificado. Verificalo primero con Google.",
  "login.oauthError.alreadyLinked": "Esta cuenta de Google ya está conectada a otra cuenta de AGROPTIMIZER.",
  "login.oauthError.linkToken": "La sesión de conexión expiró o es inválida. Confirmá tu contraseña de nuevo.",
  "login.oauthError.linkUnauthenticated": "Iniciá sesión antes de conectar una cuenta de Google.",
  "login.oauthError.linkTarget": "No encontramos tu cuenta. Iniciá sesión de nuevo y volvé a intentarlo.",
  "login.oauthError.generic": "No se pudo iniciar sesión con Google. Intentá de nuevo.",
  "emailVerify.banner.text": "Te enviamos un enlace de verificación al correo. Verificá tu dirección para habilitar la conexión de cuentas.",
  "emailVerify.banner.resend": "¿No lo recibiste? Reenviar",
  "emailVerify.banner.sending": "Enviando...",
  "emailVerify.banner.sent": "Enviado — revisá tu bandeja de entrada",
  "emailVerify.banner.dismiss": "Descartar",
  "emailVerify.banner.resentToast": "Correo de verificación enviado. Revisá tu bandeja de entrada.",
  "emailVerify.banner.resendFailed": "No se pudo enviar el correo de verificación. Intentá de nuevo en un momento.",
  "errors.notFound": "No se encontraron los datos solicitados.",
  "errors.server": "El servidor no pudo completar esta solicitud. Intentalo de nuevo.",
  "units.imperial.area": "ac",
  "units.imperial.yield": "bu/ac",
  "units.imperial.nutrient": "lb/ac",
  "units.imperial.seedingRate": "k/ac",
  "units.imperial.rowSpacing": "in",
  "units.imperial.costPerArea": "$/ac",
  "units.imperial.precipitation": "in",
  "units.imperial.temperature": "°F",
  "units.imperial.pricePerBu": "$/bu",
  "units.imperial.pricePerLb": "$/lb",
  "units.metric.area": "ha",
  "units.metric.yield": "kg/ha",
  "units.metric.nutrient": "kg/ha",
  "units.metric.seedingRate": "k/ha",
  "units.metric.rowSpacing": "cm",
  "units.metric.costPerArea": "$/ha",
  "units.metric.precipitation": "mm",
  "units.metric.temperature": "°C",
  "units.metric.pricePerBu": "$/t",
  "units.metric.pricePerLb": "$/kg",
  "crop.corn": "Maíz",
  "crop.soybean": "Soja",
  "error.auth.registrationFailed": "Falló el registro. Verificá los datos o probá con otro correo.",
  "error.auth.invalidRefreshToken": "Token de actualización inválido o expirado",
  "error.auth.invalidTokenType": "Tipo de token inválido",
  "error.auth.invalidToken": "Token de actualización inválido",
  "error.auth.userNotFound": "Usuario no encontrado",
  "error.auth.tokenRevoked": "El token fue revocado",
  "error.auth.resetLinkInvalid": "El enlace de restablecimiento es inválido o expiró.",
  "error.field.notFound": "Lote no encontrado",
  "error.field.tooLarge": "Lote demasiado grande ({acres} acres). El máximo permitido es {max_acres} acres por lote.",
  "error.job.notFound": "Tarea no encontrada",
  "error.job.notCancelable": "La tarea con estado {status} no se puede cancelar.",
  "error.sim.fieldNotFound": "Lote no encontrado",
  "error.sim.tooManyJobs": "Demasiadas tareas en curso ({count}). Esperá a que terminen las actuales.",
  "error.sim.resultNotFound": "No se encontró el resultado de la simulación",
  "error.ndvi.fieldNotFound": "Lote no encontrado",
  "error.ndvi.cooldown": "Capturado hace {days_since}d. Sentinel-2 revisita cada ~5 días — próxima captura disponible {next_date}.",
  "error.ndvi.invalidDate": "Formato de fecha inválido. Usá AAAA-MM-DD.",
  "error.ndvi.imageNotAvailable": "Imagen no disponible para esta fecha.",
  "error.ndvi.imageCleanedUp": "El archivo de imagen fue eliminado.",
  "error.ndvi.invalidMonitoringDays": "Los días de monitoreo deben estar entre {min_days} y {max_days}.",
  "error.market.fieldNotFound": "Lote no encontrado",
  "error.market.contractNotFound": "Contrato no encontrado",
  "error.llm.fieldNotFound": "Lote no encontrado o acceso denegado.",
  "error.llm.threadNotFound": "Conversación no encontrada o acceso denegado.",
  "error.llm.helpUnavailable": "Chat de ayuda temporalmente no disponible.",
  "error.rateLimit.tooMany": "Demasiadas solicitudes. Esperá un minuto.",
  "error.rateLimit.auth": "Demasiados intentos. Esperá un minuto.",
  "success.auth.passwordChanged": "Contraseña cambiada con éxito",
  "success.auth.loggedOut": "Sesión cerrada con éxito",
  "success.auth.resetLinkSent": "Si ese correo está registrado, te enviamos un enlace de restablecimiento.",
  "success.auth.passwordReset": "Contraseña restablecida con éxito. Ya podés ingresar.",
  "success.ndvi.jobInProgress": "Ya hay un análisis satelital en curso para este lote.",
  "success.ndvi.monitoringStopped": "Monitoreo detenido con éxito.",
  "success.ndvi.noMonitoring": "No se encontró ningún monitoreo activo.",
  "success.market.refreshQueued": "Todas las tareas de actualización de datos de mercado y AMS se encolaron con éxito.",
  "status.job.started": "Iniciada",
  "status.job.complete": "Completada",
  "status.job.retryingGeneric": "Reintentando",
  "status.job.failedGeneric": "La tarea falló. Intentalo de nuevo.",
  "status.ndvi.noImagery": "No se encontraron imágenes claras en la ventana reciente.",
  "common.unknown": "Desconocido",
  "fields.loading": "Cargando lotes...",
  "fields.empty": "No hay lotes aún. Dibujá un límite para crear uno.",
  "fields.rename": "Renombrar",
  "fields.delete": "Eliminar",
  "fields.renamePrompt": "Ingresá un nuevo nombre para este lote:",
  "fields.deleteConfirm": "¿Seguro que querés eliminar \"{name}\"?",
  "kpi.estYield": "Rend. Est.",
  "kpi.estProfit": "Gan. Est.",
  "kpi.fieldHealth": "Salud del Lote",
  "kpi.lastCaptured": "Última Captura",
  "kpi.growthSignal": "Señal de crecimiento",
  "kpi.today": "Hoy",
  "kpi.dayAgo": "Hace 1 día",
  "kpi.daysAgo": "Hace {n} días",
  "kpi.ariaBreakeven": "Margen de equilibrio {value}",
  "kpi.marginTooltip": "El margen por bushel es lo que ganás en cada bushel después de cubrir tus costos. Es el precio del cultivo menos el precio de equilibrio. El precio de equilibrio es el costo total por acre dividido por el rendimiento esperado.",
  "advisor.you": "Vos",
  "advisor.replyUnavailable": "Disculpá, no pude generar una respuesta.",
  "advisor.replyFailed": "Disculpá, algo falló al generar la respuesta. Intentalo de nuevo.",
  "advisor.replyError": "Disculpá, ocurrió un error. Intentalo de nuevo.",
  "satellite.condition": "Estado",
  "satellite.daysAfterPlantingShort": "DDS",
  "satellite.ndviUpdatedNudge": "Imágenes satelitales actualizadas para este lote. Última observación: verdor del cultivo={mean}, estado=\"{label}\". Preguntame cualquier cosa sobre la salud del cultivo o las tendencias del verdor.",
  "help.open": "Abrir ayuda",
  "help.errorReply": "Disculpá, algo falló. Intentalo de nuevo.",
  "login.success": "Sesión iniciada con éxito.",
  "register.success": "Cuenta creada con éxito.",
  "market.breakeven.margin": "Margen",
  "common.maxShort": "Máx",
  "simulation.submitting": "Enviando simulación...",
  "simulation.running": "Ejecutando simulación...",
  "simulation.loadingResults": "Cargando resultados...",
  "satellite.noField": "Ningún Lote Seleccionado",
  "satellite.today": "Hoy",
  "satellite.oneDayAgo": "Hace 1 día",
  "satellite.daysAgo": "Hace {n} días",
  "satellite.monitoringWaitHint": "El monitoreo cargará las imágenes automáticamente cuando haya una nueva pasada disponible.",
  "home.title": "Tus Lotes",
  "home.subtitle": "¿Qué lote necesita atención?",
  "home.mapTitle": "Mapa de lotes",
  "home.mapAriaLabel": "Mapa general de tus lotes",
  "home.lastObserved": "Última imagen {date}",
  "home.noObservation": "Sin observación aún",
  "home.status.stall_detected": "Estancamiento detectado — abrí el mapa para ver {area} marcada(s) desde la imagen anterior",
  "home.status.on_track": "La salud del cultivo se ve bien",
  "home.status.monitoring_active": "Monitoreo activo — esperando datos de tendencia",
  "home.status.stale": "Sin imagen clara hace {n} días — volvé a chequear pronto",
  "home.status.no_observations": "Esperando la primera imagen satelital",
  "home.status.low_confidence": "Imagen reciente parcialmente nublada — vista limitada",
  "home.empty.title": "Agregá tu primer lote para empezar",
  "home.empty.subtitle": "Dibujá un límite en el mapa satelital para crear un lote.",
  "home.empty.action": "Crear Lote",
  "home.loading": "Cargando lotes...",
  "home.loadError": "No se pudieron cargar los lotes. Intentalo de nuevo.",
  "home.newField": "+ Nuevo Lote",
  "home.totalArea": "Total: {area} en {n} lotes",
  "field.created": "Lote creado con éxito",
  "field.createFailed": "No se pudo crear el lote",
  "welcome.drawingHint": "Hacé clic en el mapa para colocar vértices. Hacé clic en el primer punto para cerrar el polígono.",
  "login.invalidEmail": "Formato de correo inválido",
  "login.lockedOut": "Reintentá en {seconds}s",
  "satellite.growthFromPrevToSelected": "Crecimiento de {prev} a {selected}",
  "satellite.ndviTimeSeries": "Serie Temporal NDVI",
  "sidebar.toggle": "Alternar menú",
  "common.yes": "Sí",
  "params.foliarFertAppCost": "Aplicación de Fertilizante Foliar",
  "advisor.sidebar.title": "Conversaciones",
  "advisor.sidebar.aria": "Conversaciones",
  "advisor.sidebar.sims": "Simulaciones",
  "advisor.sidebar.images": "Imágenes",
  "advisor.sidebar.untitled": "Simulación sin título",
  "advisor.sidebar.untitledSeason": "Temporada sin título",
  "advisor.sidebar.rename": "Renombrar",
  "advisor.sidebar.delete": "Eliminar",
  "advisor.sidebar.confirmDelete": "¿Eliminar?",
  "advisor.sidebar.empty": "Corré una simulación o tocá «Preguntá al Asesor sobre esta imagen» para iniciar una conversación.",
  "advisor.relTime.justNow": "ahora mismo",
  "advisor.relTime.minutesAgo": "hace {n}m",
  "advisor.relTime.hoursAgo": "hace {n}h",
  "advisor.relTime.daysAgo": "hace {n}d",
  "advisor.divider.simFallback": "Simulación",
  "advisor.divider.imageFallback": "Imagen",
  "advisor.inputGate.preData": "Corré una simulación o tocá «Preguntá al Asesor sobre esta imagen» para iniciar una conversación.",
  "advisor.openRail": "Abrir conversaciones",
  "reset.description": "Establecé una nueva contraseña para tu cuenta.",
  "reset.newPassword": "Nueva contraseña",
  "reset.confirmPassword": "Confirmá la nueva contraseña",
  "reset.confirmPlaceholder": "Repetí la nueva contraseña",
  "reset.submit": "Establecer contraseña",
  "reset.submitting": "Actualizando...",
  "reset.success": "Contraseña actualizada. Iniciá sesión con tu nueva contraseña.",
  "reset.failed": "No se pudo restablecer la contraseña. El enlace puede haber expirado — pedí uno nuevo.",
  "reset.tokenMissing": "Falta el enlace de restablecimiento o no es válido. Pedí uno nuevo.",
  "validation.password.criteriaLabel": "Requisitos de contraseña"
}
